module.exports = __webpack_public_path__ + "static/banner_1-b3fc016d7a9a1c8453525a2a32ce4522.jpg";